import { OptimizelyDecisionsParams } from 'lib/hooks/useOptimizelyDecisions';
import { OptimizelyDecisionsState } from 'redux-implementations/optimizelyDecisions';

// add abtest flag and values defined by product
export const optimizelyEventParams = (
  optimizelyDecisions?: OptimizelyDecisionsParams
): OptimizelyDecisionsState => {
  return {
    IS_UPDATED_LEAD_CTA_COPY_WEB_ENABLED: optimizelyDecisions?.testLeadCTA || false,
  };
};
